import {
  DefaultErrorFallback,
  type DefaultErrorFallbackNavigationProps,
} from '@/components/errors/DefaultErrorFallback/DefaultErrorFallback'
import {
  type NewRelicErrorPrefix,
  sendNewRelicErrorFactory,
} from '@/utils/functions/monitoring/sendNewRelicError'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { type PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useLocation } from 'react-router'

export type DefaultErrorBoundaryProps = PropsWithChildren &
  DefaultErrorFallbackNavigationProps & {
    newRelicPrefix: NewRelicErrorPrefix
    title?: string
  }

export function DefaultErrorBoundary({
  children,
  newRelicPrefix,
  title,
  ...navigationProps
}: DefaultErrorBoundaryProps) {
  const location = useLocation()

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          resetKeys={[location.pathname]}
          onReset={reset}
          onError={sendNewRelicErrorFactory(newRelicPrefix)}
          FallbackComponent={(p) => (
            <DefaultErrorFallback title={title} {...p} {...navigationProps} />
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
